import { supabase } from '@/lib/supabase';
import type { ThemeMode, ThemePalette } from '@/contexts/ThemeContext';

export interface ThemePreferencesRecord {
  user_id: string;
  mode: ThemeMode;
  palette: ThemePalette;
}

const TABLE_NAME = 'user_theme_preferences';

export async function fetchThemePreferences(
  userId: string
): Promise<ThemePreferencesRecord | null> {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('user_id, mode, palette')
    .eq('user_id', userId)
    .maybeSingle();

  if (error) {
    throw error;
  }

  return data ?? null;
}

export async function saveThemePreferences(params: {
  userId: string;
  mode: ThemeMode;
  palette: ThemePalette;
}): Promise<void> {
  const { error } = await supabase.from(TABLE_NAME).upsert({
    user_id: params.userId,
    mode: params.mode,
    palette: params.palette,
  });

  if (error) {
    throw error;
  }
}
